// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
	text-align: center;
}

.App-logo {
	pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
	.App-logo {
		animation: App-logo-spin infinite 20s linear;
	}
}

.App-header {
	background-color: #282c34;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-size: calc(10px + 2vmin);
	color: white;
}

.App-link {
	color: #61dafb;
}

@keyframes App-logo-spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}
.messageQuill {
	min-height: 100px;
}
.ql-editor {
	min-height: 200px;
}

.navBar {
	z-index: 1000 !important;
}

.background-charcoal {
	background-color: #1f2833;
}
.proxima-soft-font {
	font-family: 'Proxima Soft Medium';
}
.proxima-nova-font {
	font-family: 'Proxima Nova';
}
a {
	cursor: pointer;
}

.background-light-grey {
	background-color: #ecf0f1;
}

.proximaNovaSemibold {
	color: #ffffff;
	font-family: 'Proxima Soft Semibold';
	font-size: 14px;
	font-weight: bold;
}
.proximaNova {
	color: #22313f;
	font-family: 'Proxima Nova';
	font-weight: bold;
}
.proximaNovaMedium {
	color: #22313f;
	font-family: 'Proxima Nova Medium';
	font-weight: bold;
}
.proximaNovaSemiboldRegular {
	color: #22313f;
	font-family: 'Proxima Nova Semibold';

	font-weight: bold;
}

.fontSize14 {
	font-size: 14px;
}
.fontSize26 {
	font-size: 26px;
}
.fontSize30 {
	font-size: 30px;
}
.fontSize40 {
	font-size: 40px;
}
.pinsGrey {
	color: #22313f;
}
.pinsBackgroundGrey {
	background-color: #22313f;
}
.pinsBackgroundGreyLightGrey {
	background-color: #77848e;
}
.pinsHighlight {
	background-color: #e7f0fe;
}

.globalPointer {
	cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC;EACC,4CAA4C;CAC7C;AACD;;AAEA;CACC,yBAAyB;CACzB,iBAAiB;CACjB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,6BAA6B;CAC7B,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC;EACC,uBAAuB;CACxB;CACA;EACC,yBAAyB;CAC1B;AACD;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;AAC1B;AACA;CACC,kCAAkC;AACnC;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,oCAAoC;CACpC,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,2BAA2B;CAC3B,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,kCAAkC;CAClC,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,oCAAoC;;CAEpC,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;;AAEA;CACC,eAAe;AAChB","sourcesContent":[".App {\n\ttext-align: center;\n}\n\n.App-logo {\n\tpointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n\t.App-logo {\n\t\tanimation: App-logo-spin infinite 20s linear;\n\t}\n}\n\n.App-header {\n\tbackground-color: #282c34;\n\tmin-height: 100vh;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: calc(10px + 2vmin);\n\tcolor: white;\n}\n\n.App-link {\n\tcolor: #61dafb;\n}\n\n@keyframes App-logo-spin {\n\tfrom {\n\t\ttransform: rotate(0deg);\n\t}\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n}\n.messageQuill {\n\tmin-height: 100px;\n}\n.ql-editor {\n\tmin-height: 200px;\n}\n\n.navBar {\n\tz-index: 1000 !important;\n}\n\n.background-charcoal {\n\tbackground-color: #1f2833;\n}\n.proxima-soft-font {\n\tfont-family: 'Proxima Soft Medium';\n}\n.proxima-nova-font {\n\tfont-family: 'Proxima Nova';\n}\na {\n\tcursor: pointer;\n}\n\n.background-light-grey {\n\tbackground-color: #ecf0f1;\n}\n\n.proximaNovaSemibold {\n\tcolor: #ffffff;\n\tfont-family: 'Proxima Soft Semibold';\n\tfont-size: 14px;\n\tfont-weight: bold;\n}\n.proximaNova {\n\tcolor: #22313f;\n\tfont-family: 'Proxima Nova';\n\tfont-weight: bold;\n}\n.proximaNovaMedium {\n\tcolor: #22313f;\n\tfont-family: 'Proxima Nova Medium';\n\tfont-weight: bold;\n}\n.proximaNovaSemiboldRegular {\n\tcolor: #22313f;\n\tfont-family: 'Proxima Nova Semibold';\n\n\tfont-weight: bold;\n}\n\n.fontSize14 {\n\tfont-size: 14px;\n}\n.fontSize26 {\n\tfont-size: 26px;\n}\n.fontSize30 {\n\tfont-size: 30px;\n}\n.fontSize40 {\n\tfont-size: 40px;\n}\n.pinsGrey {\n\tcolor: #22313f;\n}\n.pinsBackgroundGrey {\n\tbackground-color: #22313f;\n}\n.pinsBackgroundGreyLightGrey {\n\tbackground-color: #77848e;\n}\n.pinsHighlight {\n\tbackground-color: #e7f0fe;\n}\n\n.globalPointer {\n\tcursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
